type EmptyTableProps = {
  emptyStateText: string;
};

const EmptyTable = ({ emptyStateText }: EmptyTableProps): JSX.Element => (
  <p className="empty state text for table">{emptyStateText}</p>
);

export default EmptyTable;
